import React from 'react';
import Svg, { ISvgProps } from './_module/Svg';

interface IProps extends Omit<ISvgProps, 'svgIcon'> {}

export default function KeepitalMessengerAppSvg(props: IProps) {
  const { width, height } = props;
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      svgIcon='<polygon class="chatbox-back brand-gray" points="9.8,12.4 21,12.4 21,4.3 2,4.3 2,15.8 4.4,15.8 4.4,18.5 6.3,15.8 9.8,15.8"/><polygon class="chatbox-front brand-primary" points="11,13.5 30,13.5 30,25.1 27.6,25.1 27.6,27.7 25.7,25.1 11,25.1"/><rect class="white" x="4.2" y="6.6" width="13.1" height="0.9"/><rect class="white" x="4.2" y="8.7" width="9.1" height="0.9"/><rect class="white" x="14.4" y="15.6" width="13.1" height="0.9"/><rect class="white" x="18.5" y="17.7" width="9.1" height="0.9"/>'
    />
  );
}
